import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import store from '@/store'

let environment = store.state.env.mode
if (environment !== 'local') {
  Sentry.init({
    dsn: 'https://7f915d98eddd4a42b319cb92e3f841ab@sentry.io/5166648',
    environment, // 모드로 구분해보자
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}
